<mat-card [class]="class">
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
